'use client';

import clickReviewsInAlternativesTrigger from '@coolblue-development/ga4-events/triggers/AlternativePrimaryItem/clickReviewsInAlternativesTrigger';
import { useAnalytics } from '@coolblue-development/next-analytics/client';
import { ProductTitleReview } from '@coolblue-development/next-patterns/client';
import type { Product } from '@features/product/typings';

const Review = ({
  review,
  url,
  productId
}: {
  review: Product['reviewMetaData'];
  url: string;
  productId: number;
}) => {
  const { trackEvent } = useAnalytics();

  return (
    <ProductTitleReview
      value={review?.averageRating ?? 0}
      reviewCount={review?.count ?? 0}
      size='small'
      href={`${url}#product-reviews`}
      onClick={() =>
        trackEvent(
          clickReviewsInAlternativesTrigger({
            item_id: productId
          })
        )
      }
    />
  );
};

export default Review;
